import { useMemo, type ReactNode } from 'react'
import {
  createTheme,
  CssBaseline,
  responsiveFontSizes,
  ThemeProvider,
  type PaletteMode,
} from '@mui/material'
import { FORMA } from '@/contratos'
import themeConfig from '@/configs/themeConfig'
import overrides from './overrides'
import palette from './palette'
import shadows from './shadows'
import typography from './typography'

/**
 * Mesma montagem do arsal-drive (`@core/theme/index.tsx`). O `spacing` de
 * 0.25rem por unidade e o pilar mais facil de perder: todo `theme.spacing(6)` do
 * design system vale 24px, e trocar pelos 8px do MUI desalinha o padding de
 * TODOS os cards de uma vez.
 */
export default function ThemeComponent({ children }: { children: ReactNode }) {
  const mode: PaletteMode = themeConfig.mode === 'dark' ? 'dark' : 'light'

  const theme = useMemo(() => {
    let t = createTheme({
      breakpoints: { values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 } },
      palette: palette(mode) as never,
      typography,
      shape: { borderRadius: FORMA.raio },
      spacing: (factor: number) => `${(FORMA.unidadeEspacamento / 16) * factor}rem`,
      mixins: { toolbar: { minHeight: 64 } },
      shadows: shadows(mode),
      components: overrides() as never,
    })
    if (themeConfig.responsiveFontSizes) t = responsiveFontSizes(t)
    return t
  }, [mode])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}
